import { Injectable } from '@angular/core';
import { Repository, State } from '@frontend-site/shared/utils';
import { createStore, select, withProps } from '@ngneat/elf';
import { NotificationData } from '../../models/notifications';

@Injectable()
export class UserNotificationsStore extends Repository<NotificationDataState> {
    notifications$ = this.store.pipe(select((p) => p.notifications));
    showBadge$ = this.store.pipe(select((p) => p.showBadge));

    constructor() {
        super(
            createStore(
                { name: 'UserNotifications' },
                withProps<NotificationDataState>({
                    notifications: [],
                    showBadge: false
                })
            )
        );
    }

    setNotifications(notifications: NotificationData[]): void {
        this.update({ notifications });
        this.update({ showBadge: !!notifications?.length });
    }

    removeNotificationById(notification: NotificationData): void {
        this.setNotifications(this.store.value.notifications.filter((item) => notification.subjectId !== item.subjectId));
    }

    removeAllNotifications(): void {
        this.setNotifications([]);
    }
}

export interface NotificationDataState extends State {
    notifications: NotificationData[];
    showBadge: boolean;
}
